export type BrandKey = "browsable" | "searchbubble";

function normalizeBrandKey(raw: unknown): BrandKey {
  const v = String(raw ?? "")
    .trim()
    .toLowerCase();

  if (v === "searchbubble") return "searchbubble";
  return "browsable";
}

export const brandKey: BrandKey = normalizeBrandKey(
  process.env.REACT_APP_BRAND
);

type BrandConfig = {
  key: BrandKey;
  name: string;
  domain: string; // apex, no protocol (e.g. searchbubble.com)
  wwwDomain: string; // www subdomain host (e.g. www.searchbubble.com)
  supportEmail: string;
};

const BRANDS: Record<BrandKey, BrandConfig> = {
  searchbubble: {
    key: "searchbubble",
    name: "Search Bubble",
    domain: "searchbubble.com",
    wwwDomain: "www.searchbubble.com",
    supportEmail: "support@searchbubble.com",
  },
  browsable: {
    key: "browsable",
    name: "Browsable",
    domain: "browsable.ai",
    wwwDomain: "www.browsable.ai",
    supportEmail: "support@browsable.ai",
  },
};

export const brand: BrandConfig = BRANDS[brandKey];

// Central place for Browsable public URLs (used during migration).
export const BROWSABLE_APEX_DOMAIN = "browsable.ai";
export const BROWSABLE_WWW_DOMAIN = "www.browsable.ai";
export const BROWSABLE_WWW_ORIGIN = `https://${BROWSABLE_WWW_DOMAIN}`;

export function formatTitle(pageTitle?: string) {
  const base = brand.name;
  const t = (pageTitle ?? "").trim();
  return t ? `${t} • ${base}` : base;
}

/**
 * Canonical public profile URL for Browsable.
 *
 * Important: DNS/TLS wildcard `*.browsable.ai` only supports single-label subdomains,
 * so usernames containing '.' must fall back to path URLs.
 */
export function getBrowsableProfileUrl(username: string) {
  const u = String(username ?? "").trim();
  // Intentionally NOT using `brand.*` here: this helper is specifically for
  // generating Browsable public URLs during the transition period.
  if (!u) return `https://${BROWSABLE_APEX_DOMAIN}`;
  // Legacy default for existing creators: browsable.ai/{username}
  return `https://${BROWSABLE_APEX_DOMAIN}/${encodeURIComponent(u)}`;
}

